import React from 'react';
import { 
    TouchableOpacity, 
    View, 
    Text, 
    StyleSheet, 
    // Modal, 
} from "react-native";

import Modal from './base/Modal';

// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from '@expo/vector-icons';
import { useNavigation } from '@react-navigation/native';
import StyledButton from '../StyledButton';
import FontStyles from '../../constants/FontStyle';
import Colors from '../../constants/Colors'

const OrderConfirmModal = ({ modalState, hideModal }) => {
    const navigation = useNavigation()
    const clickAreaRef = React.useRef()

    const goto = (screen) => {
        hideModal()
        navigation.navigate(`${screen}`)
    }
    const handleClickOutside = e => {
        e.persist()
        if (clickAreaRef.current) {
            if (e.target === clickAreaRef.current._nativeTag) {
                hideModal()
            }
        }
    }

    return (
        <Modal
            presentationStyle='overFullScreen'
            animationType="slide"
            transparent={true}
            visible={modalState}
            onRequestClose={() => {
                hideModal()
            }}>
            <View
                ref={clickAreaRef}
                onStartShouldSetResponder={handleClickOutside}
                style={styles.overlay}
            >
                <View style={styles.container}>

                    <TouchableOpacity
                        style={styles.closeButton}
                        onPress={() => {
                            hideModal()
                        }} >
                        <Text style={styles.closeButtonText}>Close</Text>
                        <Icon name='md-close' size={24} color='#FFFFFF' />
                    </TouchableOpacity>

                    <View style={[styles.card, styles.successCard]}>

                        <Icon name='ios-alert' size={57.75} color='#F9B13D' style={{ margin: 9.63 }} />
                        <Text style={[styles.cardBody, {
                            width: 238,
                            letterSpacing: 0,
                            ...FontStyles.dark,
                            ...FontStyles.size14,
                            ...FontStyles.lh20,
                            ...FontStyles.normal,
                            textAlign: 'center',
                        }]}>Your order has not been completed. Would you like to complete it now?</Text>

                        <StyledButton
                            label="Complete Order"
                            action={() => goto('Cart')}
                            size="sm"
                            style={{ marginTop: 28 }}
                        />
                        <StyledButton
                            label="Continue Shopping"
                            action={() => goto('Product')}
                            size="sm"
                            color="light"
                            style={{ marginTop: 10, marginBottom: 33 }}
                        />

                    </View>

                </View>
            </View>
        </Modal>
    )
}

export default OrderConfirmModal

const styles = StyleSheet.create({
    overlay: {
        backgroundColor: 'rgba(0,0,0,0.6)',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center'
    },
    container: {
        width: '100%',
        // paddingHorizontal: 16,
        justifyContent: 'center'
    },
    closeButton: {
        flexDirection: 'row',
        alignSelf: 'flex-end',
        marginBottom: 8,
        marginRight: 16,
    },
    closeButtonText: {
        color: Colors.whiteColor,
        ...FontStyles.size14,
        ...FontStyles.lh16,
        ...FontStyles.bold,
        alignSelf: 'center',
        marginRight: 8,
    },
    card: {
        borderTopLeftRadius: 25,
        borderTopRightRadius: 25,
        backgroundColor: '#FFFFFF',
        paddingHorizontal: 20,
        paddingTop: 24,
        paddingBottom: 16
    },
    successCard: {
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 16,
        borderBottomRightRadius: 16,
        backgroundColor: '#FFFFFF',
        marginHorizontal: 16,
        alignItems: "center"
    },
    cardHeader: {
        height: 19,
        width: 157,
        color: '#171C34',
        ...FontStyles.size16,
        ...FontStyles.lh20,
        ...FontStyles.bold,
        marginBottom: 16,
    },
    cardBody: {
        width: 288,
        ...FontStyles.dark,
        ...FontStyles.size14,
        ...FontStyles.lh20,
        ...FontStyles.normal,
    },
})